export default __webpack_public_path__ + "static/media/earphones7.1e82805f.jfif";